<template>
  <v-container fluid v-if="!loaded">
    <v-layout align-center justify-center row fill-height>
      <v-progress-circular
          indeterminate
          :size="70"
          color="primary"
        ></v-progress-circular>
    </v-layout>
  </v-container>
  <div v-else>
    <div class="wrapper" v-if="appointment && appointment.publicId">
      <div class="content" tabindex="0">
        <h1>{{messages.appointmentTitle}}</h1>
        <v-container fluid grid-list-md class="info-text">
          <div class="confirmation-text">{{messages.appointmentText}}</div>
          <div v-if="appointment.externalId">
            <strong>{{messages.commonBookingNumberText}}:</strong>
            {{appointment.externalId}}
          </div>
          <div v-for="(service, index) in services" :key="index">
            <strong>{{service.adult ? service.name + ': ' : service.name}}</strong>
            <div
              v-if="service.adult"
            >{{service.adult}} {{messages.chooseServiceContentAdults}}, {{service.child}} {{messages.chooseServiceContentChildren}}</div>
          </div>
          <div>
            <strong>{{messages.commonLocationText}}:</strong>
            {{appointment.branchName}}
          </div>
          <div>
            <strong>{{messages.commonDateAndTimeText}}:</strong>
            {{appointment.date | formatDate(selectedLanguage)}} {{appointment.time | formatTime(selectedLanguage)}}
          </div>
          <div v-if="appointment.customer.email">
            <strong>{{messages.Email}}:</strong>
            {{appointment.customer.email}}
          </div>
          <div v-if="appointment.customer.phone">
            <strong>{{messages.Phone}}:</strong>
            +{{appointment.customer.phone}}
          </div>
          <div v-if="checkShowPrices">
            <strong>{{messages.totalCost}}:</strong>
            {{appointment.totalCost}} {{messages.chooseServiceContentCurrency}}
          </div>
          <img :src="qrCodeUrl" alt="Qr code" role="presentation" v-if="configuration.showQR">
        </v-container>
        <v-container fluid grid-list-md class="info-text dark">
          <h2>{{appointment.branchName}}</h2>
          <div>
            <strong>{{messages.branchPhoneTitle}}:</strong>
            {{appointment.branch.phone}}
          </div>
          <div>
            <strong>{{messages.branchEmailTitle}}:</strong>
            {{appointment.branch.email}}
          </div>
          <div>
            <strong>{{messages.branchAddressTitle}}:</strong>
            {{appointment.branch.addressLine1}}, {{appointment.branch.addressZip}}, {{appointment.branch.addressCity}}
          </div>
          <div v-if="appointment.branch.addressLine2">
            <strong>{{messages.branchMailAddressTitle}}: {{appointment.branch.addressLine2}}, {{appointment.branch.addressZip}}, {{appointment.branch.addressCity}}</strong>
          </div>
        </v-container>
        <div v-if="$route.name === 'appointment'">
          <v-container fluid grid-list-md>
            <v-layout column align-center justify-center>
              <v-flex d-flex class="action-text">{{messages.appointmentActionsText}}</v-flex>
              <v-flex d-block class="action-button">
                <v-btn
                  :ripple="false"
                  flat
                  class="submit edit"
                  @click="rescheduleAppointment"
                >{{messages.rescheduleActionButtonText}}</v-btn>
              </v-flex>
              <v-flex d-block class="action-button">
                <v-btn
                  :ripple="false"
                  flat
                  class="submit cancel"
                  @click="cancelAppointment"
                >{{messages.cancelAppointmentActionButtonText}}</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <router-view
          :appointment="appointment"
          @deleted-appointment="appointmentDeleted"
        ></router-view>
      </div>
    </div>
    <div v-else>
      <div class="info-text error-message" role="alert">{{message}}</div>
      <v-btn
        class="submit back"
        :ripple="false"
        flat
        @click="backToStart"
      >{{messages.backToStartPageButtonText}}</v-btn>
    </div>
  </div>
</template>
<script>
import RestService from '../services/restService'
import QRCode from 'qrcode'
import { mapState } from 'vuex'

export default {
  name: 'Appointment',
  mixins: [RestService],
  data: () => ({
    appointment: {},
    services: [],
    message: '',
    qrCodeUrl: null,
    loaded: false
  }),
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'selectedLanguage'
    ]),
    checkShowPrices () {
      return this.configuration.pricesEnabled && this.configuration.showPrices
    }
  },
  methods: {
    backToStart () {
      this.$router.push({
        name: 'booking'
      })
    },
    rescheduleAppointment () {
      var _this = this
      this.$router.push({
        name: 'reschedule',
        params: {
          configuration: _this.configuration,
          // messages: _this.messages,
          appointment: _this.appointment // ,
          // selectedLanguage: _this.selectedLanguage
        }
      })
    },
    cancelAppointment () {
      this.$router.push({
        name: 'cancel'
      })
    },
    appointmentDeleted (deleted) {
      if (deleted) {
        this.appointment = false
        this.message = this.messages.cancelledAppointmentText
      }
    }
  },
  mounted () {
    var _this = this
    var appointmentId = this.$route.params.appointmentId
    this.getAppointment(appointmentId)
      .then(response => {
        var appointment = response.data
        if (appointment) {
          var today = new Date()
          var appointmentTime = new Date(
            appointment.date + ' ' + appointment.time
          )
          // var date = today.toISOString().substring(0, 10);
          if (today > appointmentTime) {
            _this.appointment = false
            _this.message = _this.messages.appointmentNotFound
          } else {
            _this.appointment = appointment
            if (_this.configuration.showQR) {
              if (_this.appointment.externalId) {
                QRCode.toDataURL(_this.appointment.externalId).then(url => {
                  _this.qrCodeUrl = url
                })
              } else {
                QRCode.toDataURL(_this.appointment.publicId).then(url => {
                  _this.qrCodeUrl = url
                })
              }
            }
            if (appointment.languageCode) {
              _this.$emit('change-language', appointment.languageCode)
            }
            if (appointment.peopleServices.length > 0 && appointment.peopleServices[0].name) {
              _this.services = appointment.peopleServices
            } else {
              _this.services = appointment.services
            }
          }
        } else {
          _this.appointment = false
          _this.message = _this.messages.appointmentNotFound
        }
        this.loaded = true
      }).catch(error => {
        this.$router.push({
          name: '404',
          params: { '0': '/404', 'error': error }
        })
      })
  }
}
</script>

<style>
.info-text.appointment-details.actions {
  border-top: 1px solid;
  border-color: var(--primary-border-color) !important;
}

.action-text {
  font-weight: 400;
  font-size: 23px;
  text-align: center;
  margin: auto;
}

.action-button {
  width: 100%;
}

.submit.edit.v-btn.v-btn--flat.theme--light,
.submit.cancel.v-btn.v-btn--flat.theme--light {
  display: block;
  margin: 0 auto;
  min-width: 400px;
}

@media (max-width: 600px) {
  .submit.edit.v-btn.v-btn--flat.theme--light,
  .submit.cancel.v-btn.v-btn--flat.theme--light {
    min-width: 100%;
  }

  .action-text {
    font-size: 18px;
  }
}
</style>
